import axios from 'axios';
import AllAccessGuestI from '../interfaces/AllAccessGuest';

const mostRecentEntryTime = (guest: AllAccessGuestI) => {
    if (!guest.entryDates || guest.entryDates.length === 0) return 0;
    return new Date(guest.entryDates[guest.entryDates.length - 1]).getTime();
};

const findGuestsByStageName = async (
    stageName: string
): Promise<AllAccessGuestI[]> => {
    const needle = stageName.trim().toLowerCase();
    if (!needle) return [];

    try {
        const { data } = await axios.get('/api/guests/all?type=allAccess');
        const guests: AllAccessGuestI[] = Array.isArray(data) ? data : [];

        const matches = guests.filter(
            (g) =>
                typeof g.stageName === 'string' &&
                g.stageName.toLowerCase() === needle
        );

        return matches.sort(
            (a, b) => mostRecentEntryTime(b) - mostRecentEntryTime(a)
        );
    } catch (error) {
        console.log(error);
        return [];
    }
};

export default findGuestsByStageName;
